import useAccessVoter from "v4/hooks/useAccessVoter";
import {ROLE_ADMIN} from "api/user/user";

export default function AdminSectionsVoter() {
    const {hasRole} = useAccessVoter();

    const canAccessAdminSections = () => {
        return hasRole(ROLE_ADMIN);
    }

    return {
        canAccessAdminSections
    };
}
